import { store } from "@/store";
import { portfolioExportActions } from "@/store/slices/portfolioExport";
import { selectSummaryStatusModal } from "@/store/slices/portfolioExport/selectors";
import { withCommas } from "@/utils/number";
import { ClockCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { Modal, Tag } from "antd";
import { useSelector } from "react-redux";
import { SummaryWithProgress } from "../hooks/useActiveSummariesWithProgress";
type SummaryStatusProps = {
  summaries?: SummaryWithProgress[] | undefined;
};
export const SummaryStatusModal = ({
  summaries = undefined
}: SummaryStatusProps) => {
  const {
    isOpen,
    highlightedSummaryId
  } = useSelector(selectSummaryStatusModal);
  const handleCancel = () => {
    store.dispatch(portfolioExportActions.setSummaryStatusModal({
      isOpen: false
    }));
  };
  const getStatus = (status: string, position: number) => {
    if (status === "pending" && position === 1) {
      return <Tag icon={<SyncOutlined spin />} color="processing">
          Processing
        </Tag>;
    }
    if (status === "pending") {
      return <Tag icon={<ClockCircleOutlined />} color="orange">
          Pending (#{position} in queue)
        </Tag>;
    }
    if (status === "error") {
      return <Tag icon={<CloseCircleOutlined />} color="error">
          Error
        </Tag>;
    }
    return <>
        <Tag icon={<ExclamationCircleOutlined />} data-sentry-element="Tag" data-sentry-source-file="SummaryStatusModal.tsx">Unknown</Tag>
      </>;
  };
  return <Modal open={isOpen} onCancel={handleCancel} title="Summaries in Progress" footer={null} data-sentry-element="Modal" data-sentry-component="SummaryStatusModal" data-sentry-source-file="SummaryStatusModal.tsx">
      <div className="flex flex-col gap-2">
        {summaries?.map(item => <div key={item.id} className={`rounded-lg border px-4 py-2 ${highlightedSummaryId === item.summary_id ? "border-blue-100 bg-blue-50" : "border-gray-100 bg-gray-50"}`}>
            <div className="grid items-center" style={{
          gridTemplateColumns: `72px 1fr`,
          gridAutoRows: "1.75em"
        }}>
              <div className="text-gray-500">Name</div>
              <div className="overflow-auto">{item.name}</div>

              <div className="text-gray-500"> Assets</div>
              <div>
                {withCommas(item.success)}
                {item.error > 0 && <span> ({withCommas(item.error)} failed)</span>}
              </div>

              <div className="text-gray-500">Group</div>
              <div>{item.group_name}</div>

              <div className="text-gray-500">Status</div>
              <div>{getStatus(item.status, item.position || 0)}</div>
            </div>
          </div>)}
      </div>
    </Modal>;
};